import { ResourceDetailFeature } from '@cibo/ui'
import { useTranslation } from 'react-i18next'
import { CheckboxBooleanYearRollupEditor } from '../CheckboxBooleanYearRollupEditor'
import { RDOnFarmDairyFeed } from './types'

export const RDOnFarmDairyFeedFeature: ResourceDetailFeature<RDOnFarmDairyFeed> = {
  traitId: 'onFarmDairyFeed',
  TaskEditor: (props: any) => {
    const { t } = useTranslation('@cibo/landmanager/OnFarmDairyFeed')

    return (
      <CheckboxBooleanYearRollupEditor
        traitId="onFarmDairyFeed"
        data-testid="onFarmDairyFeed"
        detailKey="result"
        {...props}
        title={t('question')}
      />
    )
  },
}
